import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/accommodatie',
        name: 'Accommodation',
        component: () => import('../views/Accommodation.vue')
    },
    {
        path: '/activiteiten',
        name: 'Activities',
        component: () => import('../views/Activities.vue')
    },
    {
        path: '/omgeving',
        name: 'Environment',
        component: () => import('../views/Environment.vue')
    },
    {
        path: '/contact',
        name: 'Contact',
        component: () => import('../views/Contact.vue')
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: () => import('../views/Privacy.vue')
    },
    {
        path: '/dashboard',
        name: 'Admin',
        beforeEnter: guardMyroute,
        component: () => import ('../views/Admin.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path:'*',
        redirect: '/'
    }
]

function guardMyroute (to, from, next){
    const isAuthenticated = localStorage.getItem('LoggedUser');
    if(isAuthenticated) {
        next();
        return;
    }
    next('/login');
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior (to) {
        if (to.hash) {
            return {
                selector: to.hash
            }
        }
        return{x:0,y:0};
    },
    routes
})

export default router
